import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { TMetaData } from "types/analytics.types";

const FilterColumn = ({
  metadata,
  selected = [],
  onChange,
}: {
  metadata: TMetaData[];
  selected: TMetaData[];
  onChange?: (value: TMetaData[]) => void;
}) => {
  const onHandleAll = () => {
    if (selected.length === metadata.length) {
      onChange?.([]);
    } else {
      onChange?.(metadata);
    }
  };

  const onHandleItem = (item: TMetaData) => {
    if (selected.includes(item)) {
      onChange?.(selected.filter((selectedItem) => selectedItem !== item));
    } else {
      onChange?.([...selected, item]);
    }
  };

  return (
    <Container>
      <Item label="전체 선택" isAllSelected onChange={onHandleAll} selected={selected.length === metadata.length} />
      {metadata.map((item: TMetaData, index: number) => (
        <Item
          key={index}
          label={item.name}
          isAllSelected={false}
          selected={selected.includes(item)}
          onChange={() => onHandleItem(item)}
        />
      ))}
    </Container>
  );
};

export default FilterColumn;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 8px;
  flex: 1 0 0;
  flex-wrap: wrap;
`;

const Item = ({
  label,
  selected = false,
  onChange,
  isAllSelected = false,
}: {
  label: string;
  selected?: boolean;
  onChange?: (value: boolean) => void;
  isAllSelected: boolean;
}) => {
  return (
    <ItemContainer onClick={() => onChange?.(!selected)}>
      <UI.CheckBox selected={selected} />
      <UI.Typography
        type="body02 normal"
        fontStyle="medium"
        color={isAllSelected ? "var(--alias-color-primary-normal)" : "var(--alias-color-label-neutral)"}
      >
        {label}
      </UI.Typography>
    </ItemContainer>
  );
};

const ItemContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
`;
